import { faPlus } from '@fortawesome/pro-regular-svg-icons/faPlus';
import { faTimes } from '@fortawesome/pro-regular-svg-icons/faTimes';
import { ResizeObserver } from '@juggle/resize-observer';
import { PrimeFaq, PrimeFaqKey } from '@propertypal/shared/src/types/prime';
import { config, animated, useSpring } from '@react-spring/web';
import React from 'react';
import useMeasure from 'react-use-measure';
import { useTheme } from 'styled-components';
import FontAwesomeIcon from '../../icons/FontAwesomeIcon';
import RichText from '../../rich-text/RichText';
import { QuestionWrapper, QuestionTitle, IconWrapper, ContentWrapper } from './PrimeFaq.style';

export interface QuestionProps extends PrimeFaq {
  open: boolean;
  toggle: (key: PrimeFaqKey) => void;
  orders?: boolean;
}

const PrimeFaqItem = (props: QuestionProps) => {
  const { question, answer, toggle, open, id } = props;
  const theme = useTheme();

  const [heightRef, { height }] = useMeasure({ polyfill: ResizeObserver });

  const slideInStyles = useSpring({
    config: config.default,
    from: { opacity: 0, height: 0 },
    to: {
      opacity: open ? 1 : 0,
      height: open ? height : 0,
    },
  });

  const toggleIcon = (
    <IconWrapper data-testid="toggle-question" onClick={() => toggle(id)} onKeyDown={() => toggle(id)}>
      <FontAwesomeIcon
        icon={open ? faTimes : faPlus}
        data-open={`${open}`}
        color={props.orders ? theme.primary : theme.prime.GOLD}
        data-testid="toggle-arrow"
        key={`${open}`}
      />
    </IconWrapper>
  );

  return (
    <>
      <QuestionWrapper data-testid="question" onClick={() => toggle(id)}>
        <QuestionTitle open={open}>
          {question}
          {toggleIcon}
        </QuestionTitle>
      </QuestionWrapper>
      <animated.div style={{ ...slideInStyles, overflow: open ? 'initial' : 'hidden' }} data-testid="toggle-content">
        <ContentWrapper open={open} ref={heightRef}>
          <RichText html={answer} />
        </ContentWrapper>
      </animated.div>
    </>
  );
};

export default PrimeFaqItem;
